import { marked, Renderer } from 'marked';

import sanitizer from './sanitizer';

class CustomRenderer extends Renderer {
  table(header: string, body: string) {
    return `<table width="100%">
<thead>
${header}</thead>
<tbody>
${body}</tbody>
</table>`;
  }

  link(href: string, title: string | null, text: string) {
    if (!title) {
      return `<a href="${href}" target="_blank">${text}</a>`;
    }
    return `<a href="${href}" title="${title}" target="_blank">${text}</a>`;
  }
}

export default function renderMarkdownString(str: string): string {
  const html = marked.parse(str, {
    async: false,
    breaks: true,
    gfm: true,
    headerIds: false,
    pedantic: false,
    silent: false,
    smartLists: true,
    smartypants: false,
    xhtml: true,
    renderer: new CustomRenderer(),
  });
  return sanitizer(html);
}
